import request from '@/router/axios'
import { VUE_APP_API_CONTEXT_PATH } from '@/utils/env'

const baseUrl = VUE_APP_API_CONTEXT_PATH + '/v1/dept/'

export function isCurrentUserDeptLeader() {
  return request({
    url: baseUrl + 'currentUser/isLeader',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/admin/dept.js